"use strict";
exports.__esModule = true;
exports.PENDING_SETTLEMENT = void 0;
exports.PENDING_SETTLEMENT = {
    RENT_TRACKER: {
        MAIN_TEXT: 'We’re confirming your rent submission',
        SUB_TEXT: 'If you’ve submitted your rent using the Flex payment method, we’ll notify you when the transaction has been processed. This may take up to 3 business days after you submitted.',
        CTA: 'View details'
    },
    SERVICE_ISSUE_SCREEN: {
        HEADER: 'We’re confirming your rent submission',
        MAIN_TEXT: 'You indicated that you would submit your rent to your property using Flex payment method this month.\n\nIf you’ve made a transaction, we’ll notify you when your rent has been processed. It may take up to 3 days for the Flex app to update.\n\nFor the latest status, check your property’s portal.',
        REFUND_SUB_TEXT: 'Didn’t submit your rent?',
        REFUND_CTA: 'Refund your 1st payment',
        CTA: 'Done'
    }
};
